import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Loading = ({ height = 32, width = 32, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 32 32" {...props}>
    <path
      d="M16 0.995972V5.99597"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="100%"
    />
    <path
      d="M16 30.996V25.996"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="50%"
    />
    <path
      d="M5.39355 5.38928L8.92955 8.92528"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="90%"
    />
    <path
      d="M26.6068 26.6027L23.0708 23.068"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="40%"
    />
    <path
      d="M1 15.996H6"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="80%"
    />
    <path
      d="M31 15.996H26"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="30%"
    />
    <path
      d="M5.39355 26.6027L8.92955 23.068"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="60%"
    />
    <path
      d="M26.6068 5.38928L23.0708 8.92528"
      stroke={colors.purple100}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="10%"
    />
  </SvgIcon>
);
